import { Link, useNavigate } from "react-router-dom";
import closeIcon from "../assets/images/close_icon.png";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { useTracking } from "../hooks/useTracking";
import { ActionCategory } from "../services/logging/logService";
import { Field, Form, Formik } from "formik";
import Select from "../components/Select";
import CloseIcon from "../assets/images/close_icon.png";
import BeatLoader from "react-spinners/BeatLoader";
import decryptData from "../decrypt";
import { fetchUserInfo, fetchClientsByAgentCodes, getAllAgentCodes, processAgentCodeValue } from "../services/userService";
import { handleLogout } from "../config/axios";
import { apiFetch } from '../config/fetch';
import { saveAnagraficaPdf } from "./print/anagrafica/AnagraficaClientiPDF";
import { downloadAnagraficaCSV } from "./print/anagrafica/AnagraficaClientiCSV";

export default function AnagraficaClienti() {
  const tracking = useTracking();
  const initialLoadDone = useRef(false);
  const formikRef: any = useRef();

  const [page, setPage]: any = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [explicit, setExplicit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [columns, setColumns] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [canExport, setCanExport] = useState(false);
  const [agentFilters, setAgentFilters] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [orderByColumns, setOrderByColumns] = useState([]);
  const filtersCleared = useRef(false);
  const [optionsList, setOptionsList] = useState([]);
  const [agentsLoaded, setAgentsLoaded] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isCSVDownloading, setIsCSVDownloading] = useState(false);
  const tableRef = useRef(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  interface CustomerFilters {
    stato_cliente?: string;
    codice_cliente?: string;
    codice_agente?: string;
    campo_ordinamento?: string;
    tipo_ordinamento?: string;
    agenti?: string[];
  }

  /**
   * To be refactored
   * @param orderByItem
   */

  const options = [{ value: "ragione_sociale", label: "Ragione Sociale" }];

  const changeOrderByItemOrder = (orderByItem) => {
    const newMode = orderByItem.mode === "ASC" ? "DESC" : "ASC";
    
    // Track the order change
    tracking.trackFilter(
      "anagrafica_clienti_order_change",
      {
        column: orderByItem.column,
        oldMode: orderByItem.mode,
        newMode: newMode
      },
      {
        userRole,
        timestamp: new Date().toISOString()
      }
    );
    
    setOrderByColumns([
      {
        column: orderByItem.column,
        label: orderByItem.label,
        mode: newMode,
        opened: false,
      },
    ]);
  };

  const handleOrderByChange = (newOrderByColumn) => {
    // Track the new order by selection
    tracking.trackFilter(
      "anagrafica_clienti_order_select",
      {
        column: newOrderByColumn.value,
        label: newOrderByColumn.label
      },
      {
        userRole,
        timestamp: new Date().toISOString()
      }
    );
    
    setOrderByColumns([
      {
        column: newOrderByColumn.value,
        label: newOrderByColumn.label,
        mode: "ASC",
        opened: false,
      },
    ]);
  };

  const fetchCustomers = async (filters: CustomerFilters = {}) => {
    setLoading(true);
    try {
      // Use centralized function to process agent codes
      let agentiSelezionati = [];
      
      if (selectedAgent) {
        // Process the selected agent's value
        agentiSelezionati = processAgentCodeValue(selectedAgent.value);
      } else {
        // Get all agent codes from the service
        agentiSelezionati = await getAllAgentCodes();
      }

      // Add debugging to see the actual agent codes being used
      console.log("Original agent filters:", agentFilters);
      console.log("Processed agent codes for request:", agentiSelezionati);

      // Never send an empty array for security reasons
      if (agentiSelezionati.length === 0) {
        console.error("Cannot fetch customers with empty agent array");
        return;
      }

      // This approach matches what we did in other files
      const requestBody = {
        agenti: agentiSelezionati,
        page: page + 1,
        pageSize: 1000,
        stato_cliente: filters.stato_cliente || "Tutti",
        codice_cliente: filters.codice_cliente || null,
        campo_ordinamento:
          orderByColumns.length > 0 ? orderByColumns[0].column : null,
        tipo_ordinamento:
          orderByColumns.length > 0 ? orderByColumns[0].mode : null,
      };

      console.log("Request body for utenti:", requestBody);

      const request = await apiFetch(`/nodeapi/utenti`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });

          if (request.status !== 200 && request.status !== 201) {
          handleLogout(request, "/nodeapi/utenti", JSON.stringify(requestBody));
         return;
       }

      const response = await request.json();

  

      const decrypted = await decryptData(
        response.encryptedData,
        response.encryptedKey,
        response.iv
      );
      const decryptedJson = JSON.parse(decrypted);

      if (decryptedJson.data) {
        const { data: customers = [], pagination: pagData } = decryptedJson;

        setData((prevData) =>
          page === 0 ? customers : [...prevData, ...customers]
        );
        setPagination({
          currentPage: pagData.currentPage,
          totalPages: pagData.totalPages,
        });

        setHasMore(pagData.currentPage < pagData.totalPages);

        if (decryptedJson.data) {
          setOptionsList(
            decryptedJson.data.map((cliente) => ({
              value: cliente.CODICE_CLIENTE,
              label: `${cliente.CODICE_CLIENTE} - ${cliente.RAGIONE_SOCIALE}`,
            }))
          );
        }
      }
    } catch (e) {
      console.error(e);
      setHasMore(false);
      if (page === 0) {
        setData([]);
      }
    } finally {
      setLoading(false);
      setExplicit(false);
    }
  };

  const fetchClientOptions = async (agentValue: string | null, statoCliente: string) => {
    try {
      let agentiSelezionati = [];
      if (agentValue) {
        agentiSelezionati = processAgentCodeValue(agentValue);
      } else {
        agentiSelezionati = await getAllAgentCodes();
      }

      if (agentiSelezionati.length === 0) return;

      const requestBody = {
        agenti: agentiSelezionati,
        page: 1,
        pageSize: 1000,
        stato_cliente: statoCliente || "Tutti",
        codice_cliente: null,
        campo_ordinamento: null,
        tipo_ordinamento: null,
      };

      const request = await apiFetch(`/nodeapi/utenti`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (request.status !== 200 && request.status !== 201) return;

      const response = await request.json();
      const decrypted = await decryptData(response.encryptedData, response.encryptedKey, response.iv);
      const decryptedJson = JSON.parse(decrypted);

      if (decryptedJson.data) {
        setOptionsList(
          decryptedJson.data.map((cliente) => ({
            value: cliente.CODICE_CLIENTE,
            label: `${cliente.CODICE_CLIENTE} - ${cliente.RAGIONE_SOCIALE}`,
          }))
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleAgentChange = (val, setFieldValue, values) => {
    setSelectedAgent(val);
    setFieldValue("codice_agente", val ? val.value : null);
    setFieldValue("search", null);
    setFieldValue("codice_cliente", null);
    fetchClientOptions(val ? val.value : null, values.stato_cliente);
  };

  useEffect(() => {
    const handleScroll = async () => {
      if (filtersCleared.current) {
        // If filters were cleared but not yet applied, don't load more data
        return;
      }
      if (
        window.innerHeight + Math.round(window.scrollY) >=
        document.body.offsetHeight
      ) {
        // you're at the bottom of the page
        // console.log(window.innerHeight + Math.round(window.scrollY), document.body.offsetHeight);
      }
      const { scrollTop, clientHeight, scrollHeight } =
        document.documentElement;
      if (
        window.innerHeight + Math.round(window.scrollY) >=
        scrollHeight - 20
      ) {
        if (!loading && hasMore) {
          setPage(page + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [loading, hasMore, fetchCustomers]);

  const handleSearchChange = (value, setFieldValue) => {
    setFieldValue("search", value);
    setFieldValue("codice_cliente", value ? value.value : null);

    // Salvataggio nei filtri in sessionStorage

    const savedFilters = sessionStorage.getItem("anagrafica-filters");
    let filters = savedFilters ? JSON.parse(savedFilters) : {};

    filters.search = value;
    filters.codice_cliente = value ? value.value : null; // 🔹 Salviamo il codice cliente selezionat
    sessionStorage.setItem("anagrafica-filters", JSON.stringify(filters));
  };

  const clearFiltri = async (e, setFieldValue) => {
    e.preventDefault();
    filtersCleared.current = true;

    // Track the clear filters action
    tracking.logService.logAction(
      ActionCategory.USER_ACTION,
      "clear_filters",
      "User cleared all filters in anagrafica clienti",
      {
        userRole,
        timestamp: new Date().toISOString()
      }
    );

    setFieldValue("stato_cliente", "tutti");
    setFieldValue("search", null);
    setFieldValue("codice_agente", null);
    setFieldValue("order_by", []);

    setData([]);
    setPage(0);
    setHasMore(true);
    setOrderByColumns([]);

    sessionStorage.removeItem("anagrafica-filters");

    await filterCustomers({
      stato_cliente: "tutti",
      search: null,
      codice_agente: null,
      order_by: [],
      vista: "schede",
    });
  };

  const clearOrderBy = (e, setFieldValue) => {
    e.preventDefault();
    setOrderByColumns([]);
    setFieldValue("order_by", "");
  };

  const filterCustomers = async (values, formikBag = null) => {
    try {
      setIsDataLoading(true);
      setLoading(true);

      const filtersToUse = filtersCleared.current ? {} : { ...values };

      // Se abbiamo un cliente selezionato nel dropdown, aggiorniamo `codice_cliente`
      if (filtersToUse.search) {
        filtersToUse.codice_cliente = filtersToUse.search.value;

        if (formikBag) {
          formikBag.setFieldValue("codice_cliente", filtersToUse.search.value); // 🔹 Aggiorniamo Formik
        }

        delete filtersToUse.search; // Rimuoviamo search perché non serve più
      }

      // 🔹 Assicuriamoci che codice_cliente sia incluso
      if (!filtersToUse.codice_cliente) {
        filtersToUse.codice_cliente = values.codice_cliente || null;
      }

      // Salvataggio dei filtri in sessionStorage
      const filtersToSave = {
        ...filtersToUse,
        selectedAgent,
        codice_agente: filtersToUse.codice_agente || selectedAgent?.value,
        campo_ordinamento:
          orderByColumns.length > 0 ? orderByColumns[0].column : null,
        tipo_ordinamento:
          orderByColumns.length > 0 ? orderByColumns[0].mode : null,
      };

      // Track form submission for applying filters
      tracking.trackFilter(
        "anagrafica_clienti_filter",
        filtersToSave,
        {
          action: filtersCleared.current ? "clear_filters" : "apply_filters",
          userRole,
          timestamp: new Date().toISOString()
        }
      );

      sessionStorage.setItem(
        "anagrafica-filters",
        JSON.stringify(filtersToSave)
      );

      setPage(0);
      setExplicit(true);
      setHasMore(true);
      setData([]);

      if (formikBag) {
        formikBag.resetForm({
          values: filtersCleared.current
            ? {
                stato_cliente: "tutti",
                search: null,
                codice_cliente: null,
                codice_agente: null,
                order_by: [],
                vista: "schede",
              }
            : values,
        });
      }

      // 🔹 Passiamo i nuovi filtri a fetchCustomers
      await fetchCustomers(filtersToUse);
    } catch (e) {
      console.error(e);
      // Track error
      tracking.trackError(
        "anagrafica_clienti_filter_error",
        e instanceof Error ? e : new Error(String(e)),
        { userRole }
      );
    } finally {
      setLoading(false);
      setIsDataLoading(false);
    }
  };

  interface CustomerFilters {
    stato_cliente?: string;
    codice_cliente?: string;
    codice_agente?: string;
    campo_ordinamento?: string;
    tipo_ordinamento?: string;
    agenti?: string[];
  }

  const fetchInitialAgents = async () => {
    try {
      // Use our service to fetch user information
      const { user, isSupervisor, agentCodes, agents, canExport: userCanExport } = await fetchUserInfo();
      
      console.log("User info from fetchUserInfo:", {
        isSupervisor,
        agentCodes,
        agentsCount: agents.length,
        userCanExport,
        rawAttributes: user?.attributes
      });
      
      if (!user) {
        console.error("Failed to fetch user info");
        return;
      }
      
      // Set user role
      setUserRole(isSupervisor ? "supervisor" : "agent");
      setCanExport(userCanExport);
      
      // Format agents for the component using consistent structure
      let formattedAgents = [];
      
      if (isSupervisor && Array.isArray(agents)) {
        // For supervisor: include all their group members with processed data structure
        formattedAgents = agents.map((agent) => ({
          // Store as JSON string to maintain consistent format
          db2_user_id: JSON.stringify(agent.all_codes),
          codice_agente: agent.all_codes[0] || "", // First code for display
          first_name: agent.first_name,
          last_name: agent.last_name,
          raw_codes: agent.all_codes // Store raw array for direct access
        }));
      } else if (agentCodes.length > 0) {
        // For regular agent: use their own codes with consistent structure
        formattedAgents = [{
          db2_user_id: JSON.stringify(agentCodes),
          codice_agente: agentCodes[0] || "",
          first_name: user.firstName || "",
          last_name: user.lastName || "",
          raw_codes: agentCodes // Store raw array for direct access
        }];
      }
      
      console.log("Formatted agents for UI:", formattedAgents);
      setAgentFilters(formattedAgents);
      setAgentsLoaded(true);
      
      // Load saved filters if available
      const savedFilters = sessionStorage.getItem("anagrafica-filters");
      
      if (isSupervisor) {
        // Supervisor: load saved filters if they exist
        if (savedFilters) {
          const parsedFilters = JSON.parse(savedFilters);
          if (parsedFilters.codice_agente) {
            const savedAgent = formattedAgents.find(
              (agent) => agent.db2_user_id === parsedFilters.codice_agente
            );
            if (savedAgent) {
              const formattedAgent = {
                value: savedAgent.db2_user_id,
                label: `${savedAgent.first_name} ${savedAgent.last_name}`,
              };
              
              setSelectedAgent(formattedAgent);
              
              if (formikRef.current) {
                formikRef.current.setFieldValue(
                  "codice_agente",
                  savedAgent.db2_user_id
                );
              }
            }
          }
          
          // Also restore selected customer in optionsList
          if (parsedFilters.codice_cliente && parsedFilters.search) {
            // Make sure the customer option is available in the list
            setOptionsList(prevList => {
              const exists = prevList.some(opt => opt.value === parsedFilters.codice_cliente);
              if (!exists && parsedFilters.search) {
                return [...prevList, parsedFilters.search];
              }
              return prevList;
            });
          }
        }
      } else {
        // Agent: use their codes
        const userAgentId = agentCodes.length > 0 ? agentCodes.join(',') : "";
        if (userAgentId) {
          const formattedAgent = {
            value: userAgentId,
            label: `${user.firstName} ${user.lastName}`,
          };
          
          setSelectedAgent(formattedAgent);
          
          if (formikRef.current) {
            formikRef.current.setFieldValue("codice_agente", userAgentId);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching initial agents:", error);
    } finally {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    fetchInitialAgents();
  }, []);

  useEffect(() => {
    if (agentsLoaded && !initialLoadDone.current) {
      const initializeData = async () => {
        try {
          setIsDataLoading(true);
          setLoading(true);
          
          // Check if we have saved filters with a customer selected
          const savedFilters = sessionStorage.getItem("anagrafica-filters");
          if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);
            
            // If there's a saved customer code, trigger the search with filters
            if (parsedFilters.codice_cliente) {
              await fetchCustomers({
                stato_cliente: parsedFilters.stato_cliente || "Tutti",
                codice_cliente: parsedFilters.codice_cliente,
                codice_agente: parsedFilters.codice_agente,
                campo_ordinamento: parsedFilters.campo_ordinamento,
                tipo_ordinamento: parsedFilters.tipo_ordinamento
              } as CustomerFilters);
              
              // Also restore orderByColumns if present
              if (parsedFilters.campo_ordinamento && parsedFilters.tipo_ordinamento) {
                setOrderByColumns([{
                  column: parsedFilters.campo_ordinamento,
                  label: "Ragione Sociale", // This should be dynamic based on the field
                  mode: parsedFilters.tipo_ordinamento,
                  opened: false
                }]);
              }
            } else {
              // No saved customer, fetch all
              await fetchCustomers({} as CustomerFilters);
            }
          } else {
            // No saved filters, fetch all
            await fetchCustomers({} as CustomerFilters);
          }
          
          initialLoadDone.current = true;
        } catch (error) {
          console.error("Errore nel caricamento iniziale:", error);
        } finally {
          setLoading(false);
          setIsDataLoading(false);
        }
      };
      initializeData();
    }
  }, [agentsLoaded]);

  const handleSearch = () => {
    if (formikRef.current) {
      const searchValues = formikRef.current.values;
      
      // Track the search action using the tracking hook
      tracking.trackSearch(
        "anagrafica_clienti_search",
        undefined,
        {
          filters: {
            stato_cliente: searchValues.stato_cliente || "Tutti",
            codice_cliente: searchValues.search?.value || searchValues.codice_cliente,
            codice_agente: searchValues.codice_agente || (selectedAgent ? selectedAgent.value : null),
            campo_ordinamento: orderByColumns.length > 0 ? orderByColumns[0].column : null,
            tipo_ordinamento: orderByColumns.length > 0 ? orderByColumns[0].mode : null
          },
          // Include additional metadata
          userRole,
          timestamp: new Date().toISOString()
        }
      );
      
      // Proceed with the original search function
      filterCustomers(searchValues, formikRef.current);
    }
  };

  const buildExportFilters = async () => {
    let agenti = [];
    if (selectedAgent) {
      agenti = processAgentCodeValue(selectedAgent.value);
    } else {
      agenti = await getAllAgentCodes();
    }
    const saved = sessionStorage.getItem("anagrafica-filters");
    const parsed = saved ? JSON.parse(saved) : {};
    return {
      agenti,
      stato_cliente: parsed.stato_cliente || "Tutti",
      codice_cliente: parsed.codice_cliente || null,
    };
  };

  const handlePrint = async () => {
    setIsPrinting(true);
    try {
      const filters = await buildExportFilters();
      await saveAnagraficaPdf(filters);
    } catch (error) {
      console.error("Errore durante la generazione del PDF:", error);
    } finally {
      setIsPrinting(false);
    }
  };

  const handleCSVDownload = async () => {
    setIsCSVDownloading(true);
    try {
      const filters = await buildExportFilters();
      await downloadAnagraficaCSV(filters);
    } catch (error) {
      console.error("Errore durante il download CSV:", error);
    } finally {
      setIsCSVDownloading(false);
    }
  };

  const savedFilters = sessionStorage.getItem("anagrafica-filters")
    ? JSON.parse(sessionStorage.getItem("anagrafica-filters"))
    : {};

  // ✅ Trasformiamo il valore salvato in un oggetto compatibile con <Select>
  const selectedCustomer = savedFilters.codice_cliente
    ? optionsList.find((option) => option.value === savedFilters.codice_cliente)
    : null;

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize={true}
      initialValues={{
        stato_cliente: savedFilters.stato_cliente || "Tutti",
        search: selectedCustomer || null, // ✅ Assegniamo il valore formattato
        codice_cliente: savedFilters.codice_cliente || null,
        codice_agente: savedFilters.codice_agente || null,
        campo_ordinamento: savedFilters.campo_ordinamento || null,
        tipo_ordinamento: savedFilters.tipo_ordinamento || null,
        order_by: orderByColumns,
        vista: "schede",
      }}
      validateOnChange={false}
      onSubmit={filterCustomers}
    >
      {({ isSubmitting, values, resetForm, setFieldValue }) => (
        <Form>
          <div className="py-8 pb-24 columns-3xl lg:columns-auto">
            {/* Mostra uno spinner o un segnale di caricamento se loading è true */}
            {isDataLoading || (loading && page === 0) ? (
              <div className="flex justify-center items-center h-screen">
                <BeatLoader color="#2563eb" />
              </div>
            ) : (
              <div>
                {/* -------------- */}
                <div className="py-8 columns-3xl lg:columns-auto">


                  <div className="relative">
                    <div className="sm:max-w-4xl px-5 sm:px-12 mx-auto flex flex-col justify-between mb-12 mt-[50px] md:mt-50">
                      <h2 className="hidden sm:block text-4xl text-blue-500 sm:max-w-72 font-bold sm:mb-24 ignore">
                        Anagrafica<span className="hidden sm:block">&nbsp;Clienti</span>
                      </h2>

                      <div className="filters-container flex flex-col md:flex-row md:items-center md:space-x-4 space-y-4 md:space-y-0">
                        {/* Filtro Agente, visualizzato solo per il supervisore */}
                        {userRole === "supervisor" && (
                          <div className="w-full md:w-auto flex items-center space-x-2">
                            <Select
                              value={selectedAgent}
                              onChange={(val) =>
                                handleAgentChange(val, setFieldValue, values)
                              }
                              placeholder="Seleziona Agente"
                              isClearable={true}
                              options={agentFilters.map((agent) => ({
                                value: agent.db2_user_id,
                                label: `${agent.first_name} ${agent.last_name}`,
                              }))}
                              classNames={{
                                container: (state) => `cu-wi-se w-full md:w-auto`,
                                control: (state) =>
                                  `cu-wi-se border border-neutral-300 dark:border-neutral-400`,
                                singleValue: (state) =>
                                  `!text-neutral-500 dark:!text-neutral-400`,
                                option: (state) => `hover:text-white`,
                              }}
                            />
                          </div>
                        )}

                        {/* Cliente / Codice Cliente */}
                        <div className="w-full md:w-auto">
                          <Select
                            classNames={{
                              container: (state) => `cu-wi-se w-full md:w-auto`,
                              control: (state) =>
                                `cu-wi-se border border-neutral-300 dark:border-neutral-400`,
                              singleValue: (state) =>
                                `!text-neutral-500 dark:!text-neutral-400`,
                              option: (state) =>
                                `hover:bg-blue-500 hover:text-white`,
                            }}
                            onChange={(val) =>
                              handleSearchChange(val, setFieldValue)
                            }
                            value={values.search}
                            placeholder="Cliente / Codice Cliente"
                            options={optionsList}
                            isClearable={true}
                          />
                        </div>

                        {/* Tasto Cerca */}
                        <div className="">
                          <button
                            type="button"
                            onClick={handleSearch}
                            className="py-2 px-5 bg-blue-600 text-white font-semibold hover:bg-blue-700"
                          >
                            Cerca
                          </button>
                        </div>
                      </div>
                    </div>
                    {canExport && (
                    <div className="absolute top-0 right-0 flex flex-col gap-2 sm:mr-4">

                      <button
                        type="button"
                        className="py-2 px-4 inline-flex items-center justify-center gap-x-2 text-xs font-semibold border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none rounded-l-full min-w-[100px]"
                        onClick={handlePrint}
                        disabled={isPrinting}
                      >
                        {isPrinting ? (
                          <div className="flex items-center justify-center">
                            <BeatLoader size={8} color="#ffffff" />
                          </div>
                        ) : (
                          "PDF"
                        )}
                      </button>
                      <button
                        type="button"
                        className="py-2 px-4 inline-flex items-center justify-center gap-x-2 text-xs font-semibold border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none rounded-l-full min-w-[100px]"
                        onClick={handleCSVDownload}
                        disabled={isCSVDownloading}
                      >
                        {isCSVDownloading ? (
                          <div className="flex items-center justify-center">
                            <BeatLoader size={8} color="#ffffff" />
                          </div>
                        ) : (
                          "CSV"
                        )}
                      </button>

                    </div>
                    )}
                  </div>

                  <hr className="hidden lg:block border-neutral-300 dark:border-neutral-400" />

                  <div className="lg:hidden border-b border-t border-neutral-300 dark:border-neutral-400">
                    <nav
                      className="grid grid-cols-2 space-x-2  dark:divide-neutral-400"
                      aria-label="Tabs"
                      role="tablist"
                    >
                      <div
                        id="basic-tabs-item-1"
                        data-hs-tab="#basic-tabs-1"
                        className="active p-4 flex items-center gap-5 justify-between"
                        aria-controls="basic-tabs-1"
                        role="tab"
                        onClick={(e) => {
                          const filtersSection =
                            document.getElementById("basic-tabs-1");
                          filtersSection.classList.toggle("hidden"); // Usa toggle per aprire/chiudere i filtri
                        }}
                      >
                        <div className="flex">
                          <h4 className="text-blue-600 text-xl">Filtri</h4>
                          <span className="bg-blue-500 group-active:text-blue-500 group-active:bg-white text-md text-white px-1.5 ml-4">
                            3
                          </span>
                        </div>
                        <img
                          src={CloseIcon}
                          className="w-[24px] h-[24px]"
                          onClick={(e) => {
                            e.stopPropagation(); // Previene che il click sulla X apra o chiuda i filtri
                            const filtersSection =
                              document.getElementById("basic-tabs-1");
                            filtersSection.classList.add("hidden"); // Chiudi quando clicchi sulla X
                            clearFiltri(e, setFieldValue);
                          }}
                        />
                      </div>

                      <div
                        id="basic-tabs-item-2"
                        data-hs-tab="#basic-tabs-2"
                        className="p-4 flex justify-end items-center gap-5 justify-between"
                        aria-controls="basic-tabs-2"
                        role="tab"
                        onClick={(e) => {
                          const orderBySection =
                            document.getElementById("basic-tabs-2");
                          orderBySection.classList.toggle("hidden"); // Usa toggle per aprire/chiudere Ordina Per
                        }}
                      >
                        <h4 className="text-blue-600 text-xl">Ordina Per</h4>
                        <img
                          src={CloseIcon}
                          className="w-[24px] h-[24px]"
                          onClick={(e) => {
                            e.stopPropagation(); // Previene che il click sulla X apra o chiuda l'ordine
                            const orderBySection =
                              document.getElementById("basic-tabs-2");
                            orderBySection.classList.add("hidden"); // Chiudi quando clicchi sulla X
                            clearOrderBy(e, setFieldValue);
                          }}
                        />
                      </div>
                    </nav>
                  </div>

                  <div className="">
                    <div
                      id="basic-tabs-1"
                      className="hidden"
                      role="tabpanel"
                      aria-labelledby="basic-tabs-item-1"
                    >
                      <div className="px-10">
                        <div className="">
                          <div className="py-3 flex items-center text-neutral-600 dark:text-white after:flex-[1_1_0%] after:border-t after:border-gray-600 dark:after:border-gray-200 after:ms-6">
                            Stato Cliente
                          </div>
                          <div className="flex">
                            <label
                              htmlFor="stato_cliente_attivo"
                              className={classNames({
                                "flex justify-center hover:cursor-pointer min-h-c p-2 w-full border border-r-0 border-gray-200 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700 text-neutral-600 dark:text-white":
                                  true,
                                "bg-blue-600 text-white":
                                  values.stato_cliente === "Attivo",
                              })}
                            >
                              <input
                                type="radio"
                                id="stato_cliente_attivo"
                                name="stato_cliente"
                                className="hidden shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                onChange={(e: any) =>
                                  setFieldValue(
                                    "stato_cliente",
                                    e?.target.value
                                  )
                                }
                                value="Attivo"
                                checked={values.stato_cliente === "Attivo"}
                              />
                              <span className="">Attivo</span>
                            </label>

                            <label
                              htmlFor="stato_cliente_bloccato"
                              className={classNames({
                                "flex justify-center hover:cursor-pointer min-h-c p-2 w-full border border-gray-200 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700 text-neutral-600 dark:text-white":
                                  true,
                                "bg-blue-600 text-white":
                                  values.stato_cliente === "Bloccato",
                              })}
                            >
                              <input
                                type="radio"
                                id="stato_cliente_bloccato"
                                name="stato_cliente"
                                className="hidden shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                onChange={(e: any) =>
                                  setFieldValue(
                                    "stato_cliente",
                                    e?.target.value
                                  )
                                }
                                value="Bloccato"
                                checked={values.stato_cliente === "Bloccato"}
                              />
                              <span className="">Bloccato</span>
                            </label>

                            <label
                              htmlFor="stato_cliente_tutti"
                              className={classNames({
                                "flex justify-center hover:cursor-pointer min-h-c p-2 w-full border border-gray-200 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700 text-neutral-600 dark:text-white":
                                  true,
                                "bg-blue-600 text-white":
                                  values.stato_cliente === "Tutti",
                              })}
                            >
                              <input
                                type="radio"
                                id="stato_cliente_tutti"
                                name="stato_cliente"
                                className="hidden shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                onChange={(e: any) =>
                                  setFieldValue(
                                    "stato_cliente",
                                    e?.target.value
                                  )
                                }
                                value="Tutti"
                                checked={values.stato_cliente === "Tutti"}
                              />
                              <span className="">Tutti</span>
                            </label>
                          </div>
                        </div>
                        <div className="">
                          <button
                            type="submit"
                            className="py-2 px-4 mt-6 inline-flex items-center gap-x-2 text-xs font-semibold border border-transparent bg-blue-600 text-white hover:bg-blue-700 "
                          >
                            Filtra
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      id="basic-tabs-2"
                      className="hidden px-10 py-5"
                      role="tabpanel"
                      aria-labelledby="basic-tabs-item-2"
                    >
                      {values.order_by &&
                        values.order_by.map((orderByItem) => {
                          return (
                            <div className="grid grid-cols-4 border">
                              <div className="col-span-4 px-3 py-1.5 flex items-center justify-between">
                                <h4>{orderByItem.label}</h4>
                                <div className="flex gap-2">
                                  <span
                                    className={classNames({
                                      "material-symbols-outlined cursor-pointer text-xl":
                                        true,
                                      "text-neutral-300 dark:text-natural-600":
                                        orderByItem.mode !== "DESC",
                                      "text-blue-500 dark:text-blue-400":
                                        orderByItem.mode === "DESC",
                                    })}
                                    onClick={(e) =>
                                      changeOrderByItemOrder(orderByItem)
                                    }
                                  >
                                    arrow_upward
                                  </span>
                                  <span
                                    className={classNames({
                                      "material-symbols-outlined cursor-pointer text-xl":
                                        true,
                                      "text-neutral-300 dark:text-natural-600":
                                        orderByItem.mode !== "ASC",
                                      "text-blue-500 dark:text-blue-400":
                                        orderByItem.mode === "ASC",
                                    })}
                                    onClick={(e) =>
                                      changeOrderByItemOrder(orderByItem)
                                    }
                                  >
                                    arrow_downward
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}

                      <div
                        className={classNames({
                          " hover:cursor-pointer border-neutral-300 dark:border-neutral-50 border border-b border-l border-dotted":
                            true,
                          "border-t": values.order_by.length === 0,
                        })}
                      >
                        <Select
                          onChange={handleOrderByChange}
                          value={""}
                          isTransparent
                          classNames={"hover:cursor-pointer"}
                          placeholder="+ Ordinamento"
                          options={options}
                        />
                      </div>
                      <button
                        type="submit"
                        className="py-2 px-4 mt-6 inline-flex items-center gap-x-2 text-xs font-semibold border border-transparent bg-blue-600 text-white hover:bg-blue-700 "
                      >
                        Filtra
                      </button>
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row gap-4 mt-12">
                    {/* Colonna sinistra - Filtri */}
                    <div className="hidden lg:block w-full lg:w-1/4 xl:w-1/5">
                      <div className="px-4 lg:sticky lg:top-32 overflow-y-auto max-h-[calc(100vh-8rem)] cu-h-an">
                        {/* <div className="overflow-y-scroll max-h-[75vh]"> */}
                        <div className="flex justify-between items-center">
                          <div className="flex gap-5">
                            <h4 className="text-blue-600 text-xl">Filtri</h4>
                          </div>
                          <img
                            className="h-7 w-7 cursor-pointer"
                            src={closeIcon}
                            onClick={(e) => clearFiltri(e, setFieldValue)}
                          />
                        </div>
                        <div>
                          <div className={classNames({ "": !!values.search })}>
                            <div className="py-3 flex items-center text-neutral-600 dark:text-white after:flex-[1_1_0%] after:border-t after:border-gray-600 dark:after:border-gray-200 after:ms-6">
                              Stato Cliente
                            </div>
                            <div className="flex">
                              <label
                                htmlFor="stato_cliente_attivo"
                                className={classNames({
                                  "flex justify-center min-h-c p-2 hover:cursor-pointer w-full border border-r-0 border-gray-200 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700 text-neutral-600 dark:text-white":
                                    true,
                                  "bg-blue-600 text-white":
                                    values.stato_cliente === "Attivo",
                                })}
                              >
                                <input
                                  type="radio"
                                  id="stato_cliente_attivo"
                                  name="stato_cliente"
                                  className="hidden shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                  onChange={(e: any) =>
                                    setFieldValue(
                                      "stato_cliente",
                                      e?.target.value
                                    )
                                  }
                                  value="Attivo"
                                  checked={values.stato_cliente === "Attivo"}
                                />
                                <span className="">Attivo</span>
                              </label>

                              <label
                                htmlFor="stato_cliente_bloccato"
                                className={classNames({
                                  "flex justify-center min-h-c p-2 hover:cursor-pointer w-full border border-gray-200 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700 text-neutral-600 dark:text-white":
                                    true,
                                  "bg-blue-600 text-white":
                                    values.stato_cliente === "Bloccato",
                                })}
                              >
                                <input
                                  type="radio"
                                  id="stato_cliente_bloccato"
                                  name="stato_cliente"
                                  className="hidden shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                  onChange={(e: any) =>
                                    setFieldValue(
                                      "stato_cliente",
                                      e?.target.value
                                    )
                                  }
                                  value="Bloccato"
                                  checked={values.stato_cliente === "Bloccato"}
                                />
                                <span className="">Bloccato</span>
                              </label>

                              <label
                                htmlFor="stato_cliente_tutti"
                                className={classNames({
                                  "flex justify-center min-h-c p-2 hover:cursor-pointer w-full border border-gray-200 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-700 text-neutral-600 dark:text-white":
                                    true,
                                  "bg-blue-600 text-white":
                                    values.stato_cliente === "Tutti",
                                })}
                              >
                                <input
                                  type="radio"
                                  id="stato_cliente_tutti"
                                  name="stato_cliente"
                                  className="hidden shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500  dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                  onChange={(e: any) =>
                                    setFieldValue(
                                      "stato_cliente",
                                      e?.target.value
                                    )
                                  }
                                  value="Tutti"
                                  checked={values.stato_cliente === "Tutti"}
                                />
                                <span className="">Tutti</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="">
                          <button
                            type="submit"
                            className="py-2 px-4 mt-6 inline-flex items-center gap-x-2 text-xs font-semibold border border-transparent bg-blue-600 text-white hover:bg-blue-700 "
                          >
                            Filtra
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="w-full lg:w-2/3 xl:w-3/4 p-5 pt-0">
                      {values.vista === "schede" &&
                        Array.isArray(data) &&
                        data.length > 0 && (
                          <div className="grid grid-cols-2 sm:grid-cols-3 gap-5 sm:gap-10">
                            {data.map((s, i) => (
                              <Link
                                key={i}
                                to={`/anagrafica-clienti/${s.CODICE_CLIENTE}/detail`}
                                className={classNames({
                                  "px-3": true,
                                  "border-neutral-300 dark:border-neutral-400 border-r-2 md:border-r-0":
                                    (i + 1) % 2 !== 0,
                                  "border-neutral-300 dark:border-neutral-400 md:border-r-2":
                                    (i + 1) % 3 !== 0,
                                })}
                              >
                                <h4 className="text-blue-600 text-xl font-semibold mb-4">
                                  {s.RAGIONE_SOCIALE}
                                </h4>
                                <h4 className="text-lg leading-6">
                                  ID {s.CODICE_CLIENTE}
                                </h4>
                                {/*                           <h4 className='text-lg leading-6 max-w-32' style={{ wordWrap: 'break-word' }}>{s.codice_agente}</h4> */}
                                <h4 className="text-lg leading-6">
                                  {s.STATO_CLIENTE}
                                </h4>
                              </Link>
                            ))}
                          </div>
                        )}

                      {values.vista === "lista" && (
                        <div
                          ref={tableRef}
                          className="relative table-container custom-scrollbar"
                        >
                          <table className="w-full min-w-max">
                            <thead>
                              <tr>
                                <th>Codice Cliente</th>
                                <th>Ragione Sociale</th>
                                <th>Indirizzo</th>
                                <th>Località</th>
                                <th>CAP</th>
                                <th>Stato Cliente</th>
                                <th>Agente</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.map((s, index) => (
                                <tr key={index}>
                                  <td>{s.CODICE_CLIENTE}</td>
                                  <td>{s.RAGIONE_SOCIALE}</td>
                                  <td>{s.INDIRIZZO_CLIENTE}</td>
                                  <td>{s.LOCALITA_CLIENTE}</td>
                                  <td>{s.CAP}</td>
                                  <td>{s.STATO_CLIENTE}</td>
                                  <td>{s.DESCRIZIONE_AGENTE}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* <div ref={pagination}></div> */}
                      {loading && (
                        <p className="text-center">
                          <span className="animate-spin my-5 material-symbols-outlined md-48">
                            progress_activity
                          </span>
                        </p>
                      )}
                    </div>

                    <div className="hidden lg:block w-full lg:w-1/4 xl:w-1/5">
                      <div className="px-4 lg:sticky lg:top-32">
                        <div className="flex justify-between items-center">
                          <div className="flex gap-5">
                            <h4 className="text-blue-600 text-xl">
                              Ordina per
                            </h4>
                          </div>
                          <img
                            className={classNames({
                              "h-7 w-7 cursor-pointer": true,
                              "": !!values.search,
                            })}
                            src={closeIcon}
                            onClick={(e) => clearOrderBy(e, setFieldValue)}
                          />
                        </div>

                        <div className="mt-6">
                          {values.order_by &&
                            values.order_by.map((orderByItem) => {
                              return (
                                <div
                                  className={classNames({
                                    "grid grid-cols-4 border": true,
                                    "": !!values.search,
                                  })}
                                >
                                  <div className="col-span-4 px-3 py-1.5 flex items-center justify-between">
                                    <h4>{orderByItem.label}</h4>
                                    <div className="flex">
                                      <span
                                        className={classNames({
                                          "material-symbols-outlined cursor-pointer text-xl":
                                            true,
                                          "text-neutral-300 dark:text-natural-600":
                                            orderByItem.mode !== "DESC",
                                          "text-blue-500 dark:text-blue-400":
                                            orderByItem.mode === "DESC",
                                        })}
                                        onClick={(e) =>
                                          changeOrderByItemOrder(orderByItem)
                                        }
                                      >
                                        arrow_upward
                                      </span>
                                      <span
                                        className={classNames({
                                          "material-symbols-outlined cursor-pointer text-xl":
                                            true,
                                          "text-neutral-300 dark:text-natural-600":
                                            orderByItem.mode !== "ASC",
                                          "text-blue-500 dark:text-blue-400":
                                            orderByItem.mode === "ASC",
                                        })}
                                        onClick={(e) =>
                                          changeOrderByItemOrder(orderByItem)
                                        }
                                      >
                                        arrow_downward
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                          <div
                            className={classNames({
                              "border-r border-b border border-dotted": true,
                              "border-t": values.order_by.length === 0,
                            })}
                          >
                            <Select
                              onChange={handleOrderByChange}
                              value={""}
                              isTransparent
                              placeholder={`+ Ordinamento`}
                              classNames={"hover:cursor-pointer"}
                              options={options}
                            />
                          </div>
                        </div>

                        <div>
                          <div className="">
                            <div className="">
                              <button
                                type="submit"
                                className="py-2 px-4 mt-6 inline-flex items-center gap-x-2 text-xs font-semibold border border-transparent bg-blue-600 text-white hover:bg-blue-700 "
                              >
                                Filtra
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}
